import LoadingIndicator from './LoadingIndicator';
import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

export function PageHeading({ children, className = '', ...props }) {
  return <div className={`page-header ui-page-heading ${className}`} {...props}>{children}</div>;
}
export function FilterBar({ children, className = '', ...props }) {
  return <div className={`ui-filter-bar ${className}`} {...props}>{children}</div>;
}
export function PageActions({ children, className = '', ...props }) {
  return <div className={`ui-page-actions ${className}`} {...props}>{children}</div>;
}
export function EmptyState({ title, description, icon = 'inbox', children }) {
  return <div className="ui-empty-state" role="status">
    <span className="ui-state-icon"><i className={`ti ti-${icon}`} aria-hidden="true" /></span>
    <h3>{title}</h3>{description && <p>{description}</p>}{children}
  </div>;
}
export function LoadingState({label}) {
  const { t } = useTranslation();
  return <div className="ui-loading-state" role="status" aria-live="polite">
    <LoadingIndicator decorative />{label || t('ui.loading')}
  </div>;
}
export function ErrorState({ message, onRetry, retryLabel }) {
  const { t } = useTranslation();
  return <div className="ui-error-state" role="alert"><i className="ti ti-alert-circle" aria-hidden="true" />
    <span>{message}</span>{onRetry && <button type="button" className="btn btn-outline-secondary" onClick={onRetry}>{retryLabel || t('refresh')}</button>}
  </div>;
}
const containerProps = { children: PropTypes.node, className: PropTypes.string };
PageHeading.propTypes = containerProps;
FilterBar.propTypes = containerProps;
PageActions.propTypes = containerProps;
EmptyState.propTypes = { title: PropTypes.string.isRequired, description: PropTypes.string, icon: PropTypes.string, children: PropTypes.node };
ErrorState.propTypes = { message: PropTypes.string.isRequired, onRetry: PropTypes.func, retryLabel: PropTypes.string };

LoadingState.propTypes = {label: PropTypes.string};
